import script from "./dev-abonnements.vue?vue&type=script&setup=true&lang=js"
export * from "./dev-abonnements.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__